import { render, staticRenderFns } from "./DocumentThumb.vue?vue&type=template&id=8e2f9d74&scoped=true&"
import script from "./DocumentThumb.vue?vue&type=script&lang=js&"
export * from "./DocumentThumb.vue?vue&type=script&lang=js&"
import style0 from "./DocumentThumb.vue?vue&type=style&index=0&id=8e2f9d74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2f9d74",
  null
  
)

export default component.exports